export enum SettingsRoutesEnum {
  Profile = 'profile',
  Organization = 'organization',
  Billing = 'billing',
}
